import { ProjectStateType } from "../EditProjectContext";
import { SpdrClientViewModel } from "../../ViewModel/SpdrClientViewModel";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";

export const setSpdrsOnThisRoute = (
  projectState: ProjectStateType,
  routeId: any,
  spdrsOnThisRoute?: Array<SpdrClientViewModel>
) => {
  const { project, setProject } = projectState;

  const updateFtlRoute = (ftlRoute: FtlRouteViewModel) => {
    return ftlRoute.RouteId === routeId
      ? {
          ...ftlRoute,
          SpdrsOnThisRoute: spdrsOnThisRoute,
        }
      : ftlRoute;
  };

  setProject({
    ...project,
    FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
  });
};
